module.exports = __webpack_public_path__ + "img/bangyangrenwu@3x.daa18ce2.png";